import React from 'react';
import ReferenceInput from 'components/ReferenceInput';
import { Create, SimpleForm, AutocompleteInput, DateTimeInput, BooleanInput } from 'react-admin';
import InputUtils from 'utils/input';
import PolymorphicInput from 'components/PolymorphicInput';
import JobInput from 'components/JobInput';

const CancellationsCreate = () => (
  <Create redirect="show" data-testid="cancellations-create">
    <SimpleForm>
      <JobInput />
      <PolymorphicInput
        field="personable"
        choices={[
          { id: 'Location', name: 'Location' },
          { id: 'Professional', name: 'Professional' },
        ]}
      />
      <DateTimeInput source="booked_at" />
      <BooleanInput source="cleared" />
      <ReferenceInput reference="CancellationReason" source="cancellation_reason_id">
        <AutocompleteInput optionText={InputUtils.optionText('id')} />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export default CancellationsCreate;
